import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { cyrb53Hash } from 'utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface BreadcrumbsFields {
  name: string;
  link?: string;
}

export interface BreadcrumbsProps {
  values: BreadcrumbsFields[];
}

const Breadcrumbs = ({ values }: BreadcrumbsProps) => {
  const classes = useStyles();

  const showIcon = (index: number) => values.length !== index + 1;

  return (
    <Grid container alignItems="center" data-testid={'autosky-breadcrumbs'}>
      {values.map((item, index) => (
        <Grid key={cyrb53Hash(item.name)}>
          {item.link ? (
            <Link className={classes.link} to={item.link}>
              {item.name}
            </Link>
          ) : (
            <Grid className={classes.name}>{item.name}</Grid>
          )}

          {showIcon(index) && ' > '}
        </Grid>
      ))}
    </Grid>
  );
};

export default Breadcrumbs;
